export const STATUS_META = {
  en_preparacion: { label: "En preparación", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  listo:          { label: "Lista para inventario", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  enviado:        { label: "Enviada a inventario", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
};

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-zinc-100 text-zinc-600 border-zinc-200" };
  return (
    <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-sm border ${m.cls}`} data-testid={`status-badge-${status}`}>
      {m.label}
    </span>
  );
}

export const fmtMoney = (n, cur) => {
  const v = Number(n || 0);
  if (!v) return "—";
  return `${cur === "USD" ? "$" : "MX$"}${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
